import { Component } from "react";
import './footer.styles.css'
class Footer extends Component{
    render(){
        return(
            <div className="footer">
                <footer>Made Using ReactJs </footer>
            </div>
        )
    }
}

export default Footer